import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const AsyncJSMCookieConsentBanner = withAsync({
    loader: lazyForPaint(
        () => import(/* webpackChunkName: 'jsm-cookie-consent-banner' */ './jsm-cookie-consent-banner'),
        {
            ssr: false,
        }
    ),
    LoadingSkeleton: () => null,
});

export { SSRSafeJSMCookieConsentBanner as JSMCookieConsentBanner } from './jsm-cookie-consent-banner';
